import React, { useState } from 'react';
import ChatMockup from './ChatMockup';

interface HeroPhotoProps {
  scrollTarget: React.RefObject<HTMLElement | null>;
}

/** Photo d'intervention ; retombe sur le mockup WhatsApp si l'image est absente. */
const HeroPhoto: React.FC<HeroPhotoProps> = ({ scrollTarget }) => {
  const [failed, setFailed] = useState<boolean>(false);

  if (failed) return <ChatMockup scrollTarget={scrollTarget} />;

  return (
    <img
      src="/images/brand/lucas-intervention.webp"
      alt="Lucas Olive, technicien SOS IT Services, en intervention à domicile"
      width={800}
      height={1000}
      loading="eager"
      decoding="async"
      onError={() => setFailed(true)}
      className="aspect-[4/5] w-full max-w-sm rounded-card border border-line object-cover"
    />
  );
};

export default HeroPhoto;
